import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { reconcileSessionRepository } from '@webapp/modules/accounts-payable/data-access/repositories/ReconcileSessionRepository'
import { ReconcileSession } from '@webapp/modules/accounts-payable/entities/ReconcileSession'
import { creditCardAccountQueries } from '@webapp/modules/accounts-payable/query-configs/creditCardAccountQueries'

interface UpdateReconcileSessionVariables {
  sessionId: number
  /** Session-embedding account — invalidation target (BHV-035) */
  creditcardId: number
  balance?: string
  statementDate?: string
}

export const useMutateUpdateReconcileSession = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    ReconcileSession,
    RepoError,
    UpdateReconcileSessionVariables
  >({
    mutationFn: async ({ sessionId, balance, statementDate }) =>
      new ReconcileSession(
        await reconcileSessionRepository.updateSession(sessionId, {
          balance,
          statementDate,
        })
      ),
    onSuccess: (_, { creditcardId }) => {
      queryClient.invalidateQueries({
        queryKey: creditCardAccountQueries.detail(creditcardId).queryKey,
      })
    },
  })

  return {
    updateSession: mutation.mutateAsync,
    isUpdating: mutation.isLoading,
    error: mutation.error,
  }
}
